<template>
  <div id="app">
    <router-view v-if="flag"/>
  </div>
</template>

<script>
/* eslint-disable */
import axios from 'axios'
import request from  '@/utils/request'
import config from './assets/config'
var class2type = {}
var hasOwn = class2type.hasOwnProperty 
function has (obj, path) {
  return obj != null && hasOwn.call(obj, path) && obj[path]
}
export default {
  name: 'App',
  data () {
    return {
      flag: false
    }
  },
  mounted () {
    document.title = config.title
    this.$store.commit('get_user_from_db')
    let token = '',rformname = '',parms='',parmskey=''
    if (has(this.$store.getters.loginUser, 'userid')) { 
      if (this.$store.getters.tabRoutes.length <= 0 && this.$store.getters.userMenus.length > 0) {
        let firstMenu = this.$store.getters.userMenus[0].children[0]
        // this.$router.push({path: firstMenu.path, query: {menuid: firstMenu.menuid}})
      }
      this.flag = true 
    } 
    // let m = {menuid: 27}
    // let rformname = 'comIndex'
    // // this.$router.push({name: rformname, params: m})
    // this.$store.commit('set_active_name', {name: rformname, params: m})
    if (location.search || !has(this.$store.getters.loginUser, 'userid')) {
      let parm = ''
      let token = ''
      if (location.search.substr(1).indexOf('&') === -1) {
        token = location.search.substr(1).split('=')[1]
      } else {
        parm = location.search.substr(1).split('&')

        token = parm[0].split('=')[1]
        if (parm.length >= 1) {
          rformname = parm[1].split('=')[1]
        }
        if (parm.length >= 2) {
          parms = parm[2].split('=')[1]
          parmskey = parm[2].split('=')[0]
        }
      }
    axios({
      method:'post',
      url: `${config.baseUrl}token/tokenUser`,
      headers: {
        'Authorization': `Bearer ` + token
      }
    }).then(async res => {
      let {data} = res
      data.token = token
      if (data.code && data.code === 401) {
        alert('请重新登录')
        window.location.href = `${config.webUrl}/#/login`
      }
      this.$store.commit('set_user_info', data)
      this.flag = true
      if (rformname) {
        let m = {}
        m[parmskey] = parms
        this.$router.push({name: rformname, params: m})
        this.$store.commit('set_active_name', {name: rformname, params: m})
      }
      if (this.$store.getters.tabRoutes.length <= 0) {
        let firstMenu = this.$store.getters.userMenus[0].children[0]
        // this.$router.push({path: firstMenu.path, query: {menuid: firstMenu.menuid}})
      }
    })
    }

  }
}
</script>

<style>
  @import "./assets/css/base.css"
</style>
